import { render } from "./ImageSize.vue?vue&type=template&id=320c27e9&scoped=true"
import script from "./ImageSize.vue?vue&type=script&lang=js"
export * from "./ImageSize.vue?vue&type=script&lang=js"

import "./ImageSize.vue?vue&type=style&index=0&id=320c27e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320c27e9"]])

export default __exports__